import { makeActionCreator } from '../../config/store/utils'
import { getPublicPurchaseOrdersBySeller, getPurchaseOrdersBySeller } from '../../services/uniqueSeller'
import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { formatDate } from '@chilecompra/react-kit'

export const OPEN_PURCHASE_ORDER_DIALOG = 'OPEN_PURCHASE_ORDER_DIALOG'
export const onOpenPurchaseOrderDialog = makeActionCreator(OPEN_PURCHASE_ORDER_DIALOG)

export const CLOSE_PURCHASE_ORDER_DIALOG = 'CLOSE_PURCHASE_ORDER_DIALOG'
export const onClosePurchaseOrderDialog = makeActionCreator(CLOSE_PURCHASE_ORDER_DIALOG)

export const GET_PURCHASE_ORDER_DATA = 'GET_PURCHASE_ORDER_DATA'
export const GET_PURCHASE_ORDER_DATA_ERROR = 'GET_PURCHASE_ORDER_DATA_ERROR'
export const GET_PURCHASE_ORDER_DATA_SUCCESS = 'GET_PURCHASE_ORDER_DATA_SUCCESS'
export const onGetPurchaseOrderData = makeActionCreator(GET_PURCHASE_ORDER_DATA)
export const onGetPurchaseOrderDataError = makeActionCreator(GET_PURCHASE_ORDER_DATA_ERROR, 'payload')
export const onGetPurchaseOrderDataSuccess = makeActionCreator(GET_PURCHASE_ORDER_DATA_SUCCESS, 'payload')
export const onGetPurchaseOrderDataThunk =
  ({ dni, filter, token }) =>
  async dispatch => {
    dispatch(onGetPurchaseOrderData())
    try {
      const { data } = token
        ? await getPublicPurchaseOrdersBySeller({ actionType: GET_PURCHASE_ORDER_DATA, dni, filters: filter, token })
        : await getPurchaseOrdersBySeller({ actionType: GET_PURCHASE_ORDER_DATA, dni, filters: filter })

      if (data?.payload) {
        const orders = data.payload.map(order => {
          return {
            id: order.porCode,
            urlId: `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/PurchaseOrder/Modules/PO/DetailsPurchaseOrder.aspx?qs=${order.idEncrypt}`,
            name: order.porName,
            state: order.porBuyerStatus,
            dateSend: formatDate(order.porSendDate, 'dd-MM-yyyy')
          }
        })

        dispatch(
          onGetPurchaseOrderDataSuccess({
            orders
          })
        )
      }
    } catch (error) {
      dispatch(
        onGetPurchaseOrderDataError({
          error
        })
      )
    }
  }
